import { Builder } from "@builder.io/react";
import { CareerListing } from "@/components/Career/CareerListing";  
import { registerMenuGroups, commonInputs } from "./helper";

const careerComponents = [
  {
    name: "Career Components",
    items: [
      { name: "Career Listing" },
    ]
  },
];

export const registerCareerComponents = () => {
  registerMenuGroups(careerComponents);

  Builder.registerComponent(CareerListing, {
    name: "Career Listing",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
      }),
      {
        name: "careerItems",
        type: "list",
        defaultValue: [
          {
            department: "Department 1",
            job: [
              {
                role: "Role 1",
                location: "Location 1",
                link: "/",
              },
              {
                role: "Role 2",
                location: "Location 2",
                link: "/",
              },
            ],
          },
          {
            department: "Department 2",
            job: [
              {
                role: "Role 1",
                location: "Location 1",
                link: "/",
              },
              {
                role: "Role 2",
                location: "Location 2",
                link: "/",
              },
            ],
          },
        ],
        subFields: [
          {
            name: "department",
            type: "text",
          },
          {
            name: "job",
            type: "list",
            subFields: [
              {
                name: "role",
                type: "text",
              },
              {
                name: "location",
                type: "text",
              },
              {
                name: "link",
                type: "url",
              },
            ],
          },
        ],
      },
    ],
  });

}
